import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
//*MUI
import { Box, Divider } from '@mui/material';

//*Redux
import { useDispatch, useSelector } from 'react-redux';
import action from '../../../../Redux Store/actions';

//*files
import cssClasses from './InventoryFloor.module.css';
import {
  AllotmentDiv,
  BlockDiv,
} from '../../../../Subcomponents/FloorComponent/FloorComponents';
import {
  getAllInventoryStatusFromTable,
  getAllSalesByProjectFloors,
  getAllUnitsByWingId,
  getAllUnitsStatuses,
  getAllWingsByProjectId,
  getProjectByProjectName,
  getWingsIdByWingName,
} from '../../../../Services/SustenanceService';
import FloorsIcon from "../../../../Assets/Images/Common/noProjectFound.svg";
import { Fragment } from 'react';
import ClockIcon from '../../../Icons/ClockIcon';
import { groupBy, sortBy, uniqBy } from 'lodash';
import { dismissLoader, presentLoader } from '../../../../Services/loader';

import Timer from '../../../../Subcomponents/CountDownTimer';

function InventoryFloors() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let loggedInUser = {};
  const SaleUserId = useRef("");
  loggedInUser = useSelector((state) => state.Auth.user);
  // console.log(loggedInUser);
  const [ProjectData, setProjectData] = useState([]);
  const [AllWings, setAllWings] = useState([]);
  const [Units, setUnits] = useState([]);
  const [TotalUnits, setTotalUnits] = useState(0);
  // const [TotalWings, setTotalWings] = useState(0);
  const [noFloorsPresent, setNoFloorsPresent] = useState(null);

  const { projectId, wingName } = useParams();
  const location = useLocation();
  const { TotalWings } = location.state || {};
  useEffect(() => {
    console.log("Project-Id", projectId)
  }, [projectId])

  useEffect(() => {
    SaleUserId.current = loggedInUser.userId;
    dispatch(action.activeMenu('inventory'));
    getProject();
  }, []);


  function getProject() {
    presentLoader();
    getProjectByProjectName(projectId)
      .then((resp) => {
        // console.log('Projects', resp )
        setProjectData(resp.data[0]);
        if (resp.data[0]) {
          getWingsIdByWingName(wingName)
            .then((res) => {
              setAllWings(res.data[0]);
              if (res.data[0]) {
                const WingID = res.data[0].wingId;
                getAllUnitsByWingId(projectId, WingID).then((response) => {
                  let dataUnit = groupBy(response.data, 'unitId.floorNo');
                  if (loggedInUser.roleId.level === 1) {
                    if (response.count > 0) {
                      setNoFloorsPresent(true);
                    } else {
                      setNoFloorsPresent(false);
                    }
                    // console.log(dataUnit);
                    setUnits(dataUnit);
                    setTotalUnits(response.count);
                    dismissLoader();
                  } else {
                    if (resp.data[0].smAccess === "Floors") {
                      getAllSalesByProjectFloors(projectId, SaleUserId.current, WingID).then((res) => {

                        const filteredData = Object.entries(dataUnit)
                          .filter(([floorNo, items]) =>
                            res.data.some(item2 => item2.floorNo === floorNo)
                          )
                          .reduce((acc, [floorNo, items]) => {
                            acc[`${floorNo}`] = items;
                            return acc;
                          }, {});
                        // console.log("filteredData",filteredData)
                        Object.entries(filteredData).length > 0 ? setNoFloorsPresent(true) : setNoFloorsPresent(false);

                        const totalLength = Object.values(filteredData).reduce((sum, array) => sum + array.length, 0);

                        setUnits(filteredData);
                        setTotalUnits(totalLength);
                        dismissLoader();
                      })
                        .catch((err) => {
                          console.error('getAllSalesByProjectFloors', err);
                        });

                    } else {
                      if (response.count > 0) {
                        setNoFloorsPresent(true);
                      } else {
                        setNoFloorsPresent(false);
                      }
                      // console.log(dataUnit);
                      setUnits(dataUnit);
                      setTotalUnits(response.count);
                      dismissLoader();
                    }
                  }

                }
                );
              }
            })
            .catch((err) => {
              console.error('getWingsIdByWingName', err);
            });

        }
      })
      .catch((err) => {
        console.error('getProjectByProjectName', err);
      });

    getAllUnitsStatuses(projectId, wingName)
      .then((response99) => {
        // console.log('get-all-unit-status', response99);
        const UnitsOnHold = response99.data.filter(
          (f) => f.inventoryStatusId.status === 'On Hold'
        );
        // console.log('Units-onHold', UnitsOnHold);
      })
      .catch((err) => {
        console.error('get-all-unit-status', err);
      });

    getAllInventoryStatusFromTable()
      .then((response99) => {
        // console.log('getAllInventoryStatusFromTable', response99);
        const HoldStatusId = response99.data.filter(
          (f) => f.status !== 'On Hold' && f.status !== 'Payment Pending'
        );
      })
      .catch((err) => {
        console.error('getAllInventoryStatusFromTable', err);
      });
  }
  function goToUnit(unitNo) {
    navigate(`/home/Sustenance/Details/${projectId}/Inventory/${wingName}/${unitNo}`
    );
  }

  return (
    <Box className={cssClasses.Container}>
      <Box mb={2}>
        <Box className={cssClasses.SubContainer} mb={2}>
          <Box className={cssClasses.DivContainer}>
            <Box className={cssClasses.HeaderTitle}>
              {ProjectData?.projectName}
            </Box>
            <Box className={cssClasses.SubTitle}>
              {/* {ProjectData?.addressLine2} */}
              {ProjectData?.addressLine1} , {ProjectData?.addressLine2} , {ProjectData?.addressLine3}
            </Box>
          </Box>

        </Box>

        <Divider />

        <Box className={cssClasses.titleWrap}>
          <Box className={cssClasses.Title}>
            Selected Wing :
            {/* <Box component={'span'} className={cssClasses.NumberTitle} ml={2}>
              Wing {AllWings?.wingName}
            </Box>{' '} */}
            <Box component={'span'} className={cssClasses.NumberTitle} ml={2}>
              Wing {AllWings?.displayName ? AllWings?.displayName : AllWings?.wingName}
            </Box>{' '}
          </Box>
          <Box className={cssClasses.Title}>
            Total Wings :
            <Box component={'span'} className={cssClasses.NumberTitle} ml={2}>
              {TotalWings}
            </Box>{' '}
          </Box>
          <Box className={cssClasses.Title}>
            Total Units :
            <Box component={'span'} className={cssClasses.NumberTitle} ml={2}>
              {TotalUnits}
            </Box>{' '}
          </Box>
        </Box>

        <Box className={cssClasses.Floor}>
          <Box className={cssClasses.FloorTitle}>Floor</Box>
        </Box>
        {noFloorsPresent === false &&
          <Box mt={2}>
            <Box className={cssClasses.noDataMsg}>
              <Box className={cssClasses.emptyIcon}>
                <img src={FloorsIcon} alt="No Floor Available" />
              </Box>
              <Box className={cssClasses.emptyTitle}>No Floors were Found</Box>
            </Box>
          </Box>
        }



        {sortBy(Object.keys(Units), (fl) => { return isNaN(parseInt(fl.split(' ')[1])) ? 0 : parseInt(fl.split(' ')[1]) }).map((unitKey, unitKeyIndex) => (
          <Box mb={4} key={`${unitKey}_${unitKeyIndex}`}>

            <Box className={cssClasses.firstTitle}>{unitKey}</Box>
            <Divider />
            <Box className={cssClasses.BoxDiv} justifyContent={'center'}>
              <AllotmentDiv
                style={{ backgroundColor: '#D1FADF' }}
                content={'Available'}
                Quantity={Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Available') ? Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Available').length : "0"}
              />
              <AllotmentDiv
                style={{ backgroundColor: '#FEF0C7' }}
                content={'On Hold'}
                Quantity={Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'On Hold') ? Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'On Hold').length : "0"}
              />
              <AllotmentDiv
                style={{ backgroundColor: '#FFE6D5' }}
                content={'Preselected'}
                Quantity={Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Preselected') ? Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Preselected').length : "0"}
              />
              <AllotmentDiv
                style={{ backgroundColor: 'rgb(249 171 165)' }}
                content={'Sold'}
                Quantity={Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Sold') ? Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Sold').length : "0"}
              />
              {/* // ! to hide these status as per client requirement => 28 March, 2023 */}
              {/* <AllotmentDiv
                style={{ backgroundColor: '#FEE4E2' }}
                content={'Payment Pending'}
                // content={'Alloted'}
                Quantity={Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Payment Pending') ? Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Payment Pending').length : "0"}
              />

              <AllotmentDiv
                style={{ backgroundColor: '#EFF8FF' }}
                content={'Kyc Pending'}
                Quantity={Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Kyc Pending') ? Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Kyc Pending').length : "0"}
              />
              <AllotmentDiv
                style={{ backgroundColor: '#ECFDFF' }}
                content={'Kyc Done'}
                Quantity={Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Kyc Done') ? Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Kyc Done').length : "0"}
              />
              <AllotmentDiv
                style={{ backgroundColor: '#FFFAEB' }}
                content={'SDR Payment Pending'}
                Quantity={Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'SDR Payment Pending') ? Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'SDR Payment Pending').length : "0"}
              />
              <AllotmentDiv
                style={{ backgroundColor: '#F4EBFF' }}
                content={'Reserved'}
                Quantity={Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Reserved') ? Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Reserved').length : "0"}
              />
              <AllotmentDiv
                style={{ backgroundColor: '#F2F4F7' }}
                content={'Locked'}
                Quantity={Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Locked') ? Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Locked').length : "0"}
              /> */}
            </Box>
            <Divider />

            <Box className={cssClasses.MainDiv}>
              <Box className={cssClasses.flexRow}>
                <>
                  {sortBy(Units[unitKey], "unitId.unitNo")?.map((unit, index) => (
                    <BlockDiv
                      key={`${unit}_${index}`}
                      clicked={() => {
                        if (unit.Flag === true) {
                          console.log("exists in event")
                        } else {
                          goToUnit(unit.unitId.unitId);
                        }

                      }}
                      paired={unit.unitId.inventoryMergeId ? true : false}
                      // ! do not show SM here
                      // Name={unit.unitId.inventoryStatusId.status === 'On Hold' ? <p className={cssClasses.Manager}>SM:{unit?.unitId?.leadId?.userId?.name}</p> : ""}
                      // NameTitle={unit.unitId.inventoryStatusId.status === 'On Hold' ? unit.unitId?.leadId?.userId?.name : ""}
                      pairedInfo={(unit?.unitId.unitId === unit?.unitId.inventoryMergeId?.unit1Id) ? `Paired with ${unit?.unitId.inventoryMergeId?.unit2No}` : `Paired with ${unit?.unitId.inventoryMergeId?.unit1No}`}
                      style={unit.Flag === true ? { color: '#344054', backgroundColor: '#F2F4F7' } : unit.unitId.inventoryStatusId.status === 'Available' ? { color: '#027A48', backgroundColor: '#D1FADF' } : "" ||
                        unit.unitId.inventoryStatusId.status === 'On Hold' ? { color: '#B54708', backgroundColor: '#FEF0C7' } : "" ||
                          unit.unitId.inventoryStatusId.status === 'Payment Pending' ? { color: '#B42318', backgroundColor: '#FEE4E2' } : "" ||
                          unit.unitId.inventoryStatusId.status === 'Sold' ? { color: 'rgb(181 14 1)', backgroundColor: 'rgb(249 171 165)' } : "" ||
                            unit.unitId.inventoryStatusId.status === 'Reserved' ? { color: '#6941C6', backgroundColor: '#F4EBFF' } : "" ||
                              unit.unitId.inventoryStatusId.status === 'Locked' ? { color: '#344054', backgroundColor: '#F2F4F7' } : "" ||
                                unit.unitId.inventoryStatusId.status === 'Preselected' ? { color: '#FF4405', backgroundColor: '#FFE6D5' } : "" ||
                                  unit.unitId.inventoryStatusId.status === "Kyc Pending" ? { color: "#0E7090", backgroundColor: "#EFF8FF", } : "" ||
                                    unit.unitId.inventoryStatusId.status === "Kyc Done" ? { color: "#2E90FA", backgroundColor: "#D1E9FF", } : "" ||
                                      unit.unitId.inventoryStatusId.status === "SDR Payment Pending" ? { color: "#B54708", backgroundColor: "#FFFAEB", } : ""}
                      time={unit.unitId.inventoryStatusId.status === 'On Hold' &&
                        unit.unitId.unitHoldTime &&
                        <Fragment>
                          <Box className={cssClasses.Clock} mr={1}>
                            <Box component={'span'}><ClockIcon color='#B54708' fill={'none'} /></Box>
                            <Timer startFrom={unit.unitId.unitHoldTime} onComplete={() => { }}
                              timeFormatter={(time) => {
                                return (<span>{`0${Math.floor(Math.abs(new Date().getTime() - new Date(unit.unitId.unitHoldTime).getTime()) / (1000 * 60 * 60))}`.slice(-2)}:{`0${Math.floor(Math.abs(new Date().getTime() - new Date(unit.unitId.unitHoldTime).getTime()) / (1000 * 60)) % 60}`.slice(-2)}:{`0${Math.floor(Math.abs(new Date().getTime() - new Date(unit.unitId.unitHoldTime).getTime()) / 1000) % 60}`.slice(-2)}</span>)
                              }}
                            />
                          </Box>
                        </Fragment>
                        // ! vedashree changes ==> why Release units called here?
                        // EventDurationData[0]?.autoReleaseUnits === true ? ReleasingUnits(unit) :
                        //  [unit.unitId.unitHoldTime ? (
                        //    <Fragment>
                        //      <Box className={cssClasses.Clock}>
                        //        <Box component={'span'}><ClockIcon color='#B54708' fill={'none'} /></Box>

                        //        <Timer startFrom={new Date(unit.unitId.unitHoldTime).getMilliseconds()} onComplete={() => { console.log("hello!") }}
                        //          timeFormatter={(time) => {
                        //            return (<span>{'00'}:{`0${Math.floor(time / 60)}`.slice(-2)}:{`0${time % 60}`.slice(-2)}</span>)
                        //          }}
                        //        />
                        //      </Box>
                        //    </Fragment>

                        //  ) : (
                        //    <Fragment>
                        //      <Box className={cssClasses.Clock} mr={1}>
                        //        <Box component={'span'} mr={1.5}><ClockIcon color='#B54708' fill={'none'} /></Box>
                        //        <Stopwatch />
                        //      </Box>
                        //    </Fragment>
                        //  )] 
                        //  : ""
                      }
                      margin={unit.Flag === true ? 2 : unit.unitId.inventoryStatusId.status === 'On Hold' ? 0.5 : 3}
                      // Size={unit.unitId.inventoryTypeId.type}
                      flatNo={unit.unitId.unitNo}
                      // displayUnitType={unit.unitId.displayUnitType}
                      displayUnitType={
                        ProjectData?.displayInventoryType?.includes('Display Unit Type') && unit.unitId.displayUnitType !== null ?
                          unit.unitId.displayUnitType : ''}
                      Size={ProjectData?.displayInventoryType?.includes('Inventory Type') ?
                        unit.unitId.inventoryTypeId.type : ''}
                      // Price={`₹ ${numDifferentiation(unit.BSP)}`}
                      UnitOf={unit.unitId.unitOf}
                    />
                  ))}
                </>

              </Box>
            </Box>

            <Divider />
          </Box>
        ))
        }

      </Box>
    </Box>
  );
}

export default InventoryFloors;
